import { render, staticRenderFns } from "./transfer-detail.vue?vue&type=template&id=d986c540&"
import script from "./transfer-detail.vue?vue&type=script&lang=js&"
export * from "./transfer-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports